export class FacePressuresForcesData {

    constructor(calculation, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.calculation = calculation ?? null;
        this.wedgeSlidingAngleZeta = data.wedgeSlidingAngleZeta ?? null;
        this.slidingWedgeWeightG = data.slidingWedgeWeightG ?? null;
        this.rectangularAreaRequiredSupportEarthForceEre = data.rectangularAreaRequiredSupportEarthForceEre ?? null;
        this.verticalLoadFromSolidPrismPv = data.verticalLoadFromSolidPrismPv ?? null;
        this.verticalSlipSurfaceShearForceFromCohesionTc = data.verticalSlipSurfaceShearForceFromCohesionTc ?? null;
        this.verticalSlipSurfaceShearForceFromFrictionTr = data.verticalSlipSurfaceShearForceFromFrictionTr ?? null;
        this.verticalSlipSurfaceShearForceFromFrictionCohesionT = data.verticalSlipSurfaceShearForceFromFrictionCohesionT ?? null;
        this.rectangularAreaRequiredSupportWaterForceWre = data.rectangularAreaRequiredSupportWaterForceWre ?? null;
        this.tunnelFaceRequiredSupportWaterForceWci = data.tunnelFaceRequiredSupportWaterForceWci ?? null;
        this.tunnelFaceRequiredSupportEarthForceEmaxci = data.tunnelFaceRequiredSupportEarthForceEmaxci ?? null;
        this.requiredMinimumSupportForceAtTunnelAxisFaxis1 = data.requiredMinimumSupportForceAtTunnelAxisFaxis1 ?? null;
        this.tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcis = data.tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcis ?? null;
        this.tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcis = data.tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcis ?? null;
        this.requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2S = data.requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2S ?? null;

    }

}
